import "./App.css";
import "./sass/custom.scss";
import PDFGeneratorComponent from "./components/PDFGeneratorComponent.js";
import { useEffect, useState } from "react";
import { decodeBase64Url } from "./utilFunction/decodeUtils"; // Replace with the actual path to decodeUtils.js
import AntheLogo from "./assets/aakash-logo.png";
import AakashLogo from "./assets/AakashLogo.png";
import errorScreen from "./assets/errorScreen.png";
import { Col, Container, Row } from "reactstrap";
import config from "./config";
// import Response from "./components/response.json";

function App() {
  const [dataFromApi, setDataFromApi] = useState({}); // State to store data from the second API call
  const [errorPage, setErrorPage] = useState(false);
  const [isQualified, setIsQualified] = useState(false);
  const [decodedData, setDecodedData] = useState(null);
  const [loader, setLoader] = useState(true);
  const [allowRender, setAllowRender] = useState(false);

  const TEST_PLAYER_GET_TOKEN_URL = config.TOKEN_API;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedUrl = urlParams.get("data");

    if (encodedUrl) {
      const decodedData = decodeBase64Url(encodedUrl);
      decodedData.exam_type = decodedData.exam_type || "ANTHE";
      setDecodedData(decodedData);
      document.title =
      decodedData.exam_type === "IAT" ? "IAT Result" : decodedData.exam_type === "iACST" ? "iACST Result" : decodedData.exam_type === "AKTHE" ? "AKTHE Result" : "ANTHE Result"; 
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const hostname = window.location.hostname;

    // Match exact domains
    const validDomains = [
      "result.aakash.ac.in",
      "result-qa.aakash.ac.in"
    ];

    if (validDomains.includes(hostname)) {
      // Avoid duplicates
      let metaTag = document.querySelector('meta[name="robots"]');
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.name = "robots";
        document.head.appendChild(metaTag);
      }
      metaTag.content = "noindex, nofollow";
    }
  }, []);


  async function getJwtToken() {
    const url = TEST_PLAYER_GET_TOKEN_URL;
    const headers = {
      "Content-Type": "application/json",
      Authorization: config.TEST_PLAYER_RESULT_JWT_TOKEN,
    };

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        timeout: 1000,
      });

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (data.message === "Success" && data.data) {
        const token = data.data;

        return token;
      } else {
        console.error("Test player token API response:", data);
        setLoader(false);
        return null;
      }
    } catch (error) {
      console.log('abc');
      console.error("Error while fetching token:", error);
      let resObj = {
        "roll number": decodedData.roll_no,
        exam_type: decodedData.exam_type,
      };

      window.webengage.track(
        `${decodedData.exam_type}_db_main_result_student_view_error`,
        resObj
      );
      setErrorPage(true);
      setLoader(false);
      return null;
    }
  }

  async function callAnotherApi(token, rollNum) {
    let apiUrl;
    if (rollNum) {
      setErrorPage(false);
      apiUrl = config.RESULT_API + rollNum;
      if ( decodedData?.exam_type === "iACST") {
        apiUrl = config.IACST_API + rollNum;
      }
    } else {
      setErrorPage(true);
      return;
    }

    // const apiUrl =
    //   "http://testplayerapi-qa.aakash.ac.in/stage/test_player/anthe-result?rollNo=501237210030";
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const responseData = await response.json();

      let finalresponse = responseData.data;
      
      fetchBranchData(finalresponse);
      // setDataFromApi(finalresponse);
    } catch (error) {
      let resObj = {
        "roll number": decodedData.roll_no,
        exam_type: decodedData.exam_type,
      };
      
      window.webengage.track(
        `${decodedData.exam_type}_db_main_result_student_view_error`,
        resObj
      );
      console.error("Error while fetching data from the API:", error);
      setLoader(false);
      setErrorPage(true);
    }
  }

  async function fetchJwtToken() {
    try {
      const tokenFromParams = decodedData?.token;
      const rollNum = decodedData?.roll_no || decodedData?.roll_number;
      let token = tokenFromParams;

      if (!tokenFromParams) {
        token = await getJwtToken();
      }

      if (token) {
        // Calling the second API with the retrieved token
        await callAnotherApi(token, rollNum);
      }
    } catch (error) {
      let resObj = {
        "roll number": decodedData.roll_no,
        exam_type: decodedData.exam_type,
      };

      window.webengage.track(
        `${decodedData.exam_type}_db_main_result_student_view_error`,
        resObj
      );
      console.error("Error in useEffect:", error);
      setLoader(false);
      setErrorPage(true);
    }
  }

  useEffect(() => {
    decodedData && fetchJwtToken();
    // eslint-disable-next-line
  }, [decodedData]);

  async function fetchPsId(data) {
    try {
      const response = await fetch(
        config.GET_PSID +
          new URLSearchParams({
            rollNo: data.profile.roll_number,
          })
      );

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const responseData = await response.json();
      let apiData = data;
      const updatedApiData = { ...apiData };
      updatedApiData.profile.psId = responseData.data.psid;
      updatedApiData.profile.anthetwo = responseData.data.anthetwo;
      setDataFromApi(updatedApiData);
      setLoader(false);
      setAllowRender(true);
    } catch (error) {
      let resObj = {
        "roll number": decodedData.roll_no,
        exam_type: decodedData.exam_type,
      };

      window.webengage.track(
        `${decodedData.exam_type}_db_main_result_student_view_error`,
        resObj
      );
      console.error("Error while fetching data from the API:", error);
      setLoader(false);
      setErrorPage(true);
    }
  }

  async function fetchBranchData(data) {
    try {
      const response = await fetch(
        config.GET_BRANCH_DETAIL +
          new URLSearchParams({
            centerId: data.profile.branch_id,
            exam_type: decodedData.exam_type,
          })
      );

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }

      const responseData = await response.json();
      let apiData = data;
      apiData.centerData = responseData.data;
      if (apiData) {
        let qualified_status = apiData.scholarship.status.toLowerCase();
        if (qualified_status === "qualified") {
          setIsQualified(true);
        } else setIsQualified(false);
      }
      setDataFromApi(apiData);
      fetchPsId(apiData);
    } catch (error) {
      let resObj = {
        "roll number": decodedData.roll_no,
        exam_type: decodedData.exam_type,
      };

      window.webengage.track(
        `${decodedData.exam_type}_db_main_result_student_view_error`,
        resObj
      );
      console.error("Error while fetching data from the API:", error);
      setLoader(false);
      setErrorPage(true);
    }
  }
  
  return (
    <div className="App">
      <>
        {errorPage ? (
          <Container style={{ fontFamily: "Outfit-Regular" }}>
            <div className="d-flex mt-5">
              <img width={"100"} src={AakashLogo} alt="anthe logo" />
            </div>
            <Row
              className="justify-content-center align-items-center centerDiv"
              // style={{ height: "50vh" }}
            >
              <Col xs={12} lg={6}>
                <img src={errorScreen} width={"100%"} />
              </Col>
              <Col
                sm={10}
                className="my-4 align-items-center justify-content-center mx-auto"
              >
                <h2 className="fw-bold">Your result will be available soon.</h2>
                <p className="fw-lighter font-size-30 text-dark-grey">
                  For any queries please reach out to "
                  <a
                    href={`tel:${
                      decodedData?.exam_type == "iACST"
                        ? 7303529494
                        : 7303749393
                    }`}
                    className="contactDetails fw-bold text-blue"
                    style={{ textDecoration: "none" }}
                  >
                    {decodedData?.exam_type == "iACST"
                      ? 7303529494
                      : 7303749393}
                  </a>
                  "{" "}
                  <a
                    href={`mailto: ${
                      decodedData?.exam_type === "iACST"
                        ? "iacstsupport@aesl.in"
                        : decodedData?.exam_type === "AKTHE"
                        ? "akthesupport@aesl.in"
                        : "anthesupport@aesl.in"
                    }`}
                    className="contactDetails fw-bold text-blue"
                  >
                    {decodedData?.exam_type === "iACST"
                      ? "iacstsupport@aesl.in"
                      : decodedData?.exam_type === "AKTHE"
                      ? "akthesupport@aesl.in"
                      : "anthesupport@aesl.in"}
                  </a>
                </p>
              </Col>
            </Row>
          </Container>
        ) : (
          <>
            {loader && (
              <div className="spinner-container">
                <div className="spinner"></div>
              </div>
            )}

            <div style={{ visibility: loader ? "hidden" : "visible" }}>
              <PDFGeneratorComponent
                Response={dataFromApi}
                isQualified={isQualified}
                decodedData={decodedData}
                loader={loader}
                allowRender={allowRender}
                setLoader={setLoader}
                setErrorPage={setErrorPage}
              />
            </div>
          </>
        )}
      </>
    </div>
  );
}

export default App;
